<template>
  <div>
    <data-table :service="service"
                :entity="entity"
                :columns="columns"
                :disable-permission-checks="true"
                operations="edit"
                ref="table">
      <template v-slot:active="{row}">
        <status-badge :status="row.active ? $t('generic.active'): $t('generic.inactive')"/>
      </template>
      <template v-slot:type="{row}">
        <status-badge type="primary" :status="row.type">
          {{row.type}}
        </status-badge>
      </template>
      <template v-slot:enabled="{row}">
        <status-badge :status="row.enabled ? $t('generic.enabled'): $t('generic.disabled')"/>
      </template>
      <template v-slot:implementation="{row}">
        <a v-if="row.url" @click.stop="" :href="row.url" target="_blank" rel="noopener">
          {{row.implementation}}
        </a>
        <template v-else>{{$t('generic.na')}}</template>
      </template>
      <template v-slot:created_by="{row}">
        <span>{{row.created_by || 'N/A'}}</span>
      </template>
      <template v-slot:created_at="{row}">
        <span>{{$formatDate(row.created_at, FRIENDLY_DATE_FORMAT)}}</span>
      </template>
    </data-table>
  </div>
</template>
<script>
  import { entities } from 'src/config/routeTypes'
  import { FRIENDLY_DATE_FORMAT } from 'src/config/dateUtils'
  import Badge from 'src/components/Badge'
  import ThirdPartiesService from 'src/services/ThirdPartiesService'

  export default {
    name: 'third-parties-list',
    components: {
      Badge
    },
    data () {
      return {
        service: ThirdPartiesService,
        entity: entities.THIRD_PARTY,
        FRIENDLY_DATE_FORMAT
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'name',
            label: this.$t('generic.name'),
            minWidth: '160px',
            sortable: true
          },
          {
            prop: 'implementation',
            label: this.$t('thirdParties.list.implementation'),
            minWidth: '170px',
            sortable: true
          },
          {
            prop: 'type',
            label: this.$t('generic.type'),
            minWidth: '120px',
            sortable: true
          },
          {
            prop: 'active',
            label: this.$t('generic.active'),
            minWidth: '100px',
            sortable: true
          },
          {
            prop: 'enabled',
            label: this.$t('generic.enabled'),
            minWidth: '100px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '130px',
            sortable: true
          }
        ]
      },
    }
  }
</script>
<style>
</style>
